<template>
  <div class="">
    <!-- Hero -->
    <div
      class="flex p-4 pt-0 lg:pl-8 lg:pr-8 lg:pb-8 mt-20 lg:mt-0 h-[80vh] lg:h-auto"
    >
      <div
        class="home-banner relative bg-center bg-cover hero lg:h-152 w-full flex flex-col justify-end rounded-xl overflow-hidden"
        :style="{ backgroundImage: 'url(' + settings.banner_hero + ')' }"
      >
        <!-- Duplicated menu buttons to deal with scrollbar bullshit -->
        <div
          class="transition-all absolute top-0 text-xs right-0 rounded-bl-xl overflow-hidden z-40"
        >
          <div class="flex pr-px">
            <div
              v-if="isOverflowing"
              class="bg-black hover:bg-primary text-white cursor-pointer z-20 rounded-bl-xl overflow-hidden hidden lg:flex items-center justify-center gap-2 py-2 px-8 relative left-2 z-10"
              @click="showFullMenu"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-4 h-4"
              >
                <path
                  fill-rule="evenodd"
                  d="M3 9a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 9Zm0 6.75a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z"
                  clip-rule="evenodd"
                />
              </svg>

              See full menu
            </div>
            <div
              v-else
              class="cw-gradient text-white z-20 rounded-bl-xl overflow-hidden flex items-center justify-center gap-2 py-2 px-8 relative left-2 z-10"
            >
              <div>
                <img
                  src="/img/logo-cw.png"
                  alt="CareerWise logo"
                  class="w-5 mr-2"
                />
              </div>
              <div
                class="flex flex-col cursor-pointer"
                @click="openMarketingSite"
              >
                <h5 class="text-[8px] text-white font-thin mb-0">Powered by</h5>
                <h5 class="text-xs font-bold text-white mb-0">CareerWise</h5>
              </div>
            </div>
            <div
              v-if="!user"
              :class="[
                isOverflowing ? 'bg-truegray-700' : 'bg-black',
                //  activeMenuItem === 'Home'
                //   ? 'rounded-tr-xl'
                //   : 'rounded-br-xl',
              ]"
              class="text-white rounded-bl-xl overflow-hidden hidden lg:flex items-center justify-center gap-2 py-2 px-8 cursor-pointer z-20 rounded-tr-xl"
              @click="showLoginModal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-4 h-4"
              >
                <path
                  fill-rule="evenodd"
                  d="M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
                  clip-rule="evenodd"
                />
              </svg>

              Login
            </div>
            <div
              v-if="user"
              :class="[
                isOverflowing
                  ? 'bg-truegray-700 hover:bg-truegray-500'
                  : 'bg-black hover:bg-truegray-700',
                //   scrolledToTop && activeMenuItem === 'Home'
                //     ? 'rounded-tr-xl'
                //     : 'rounded-br-xl',
              ]"
              class="transition-all text-white rounded-bl-xl overflow-hidden hidden lg:flex items-center justify-center gap-2 py-2 px-8 cursor-pointer z-20 rounded-tr-xl"
              @click="openAdminMenu"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-4 h-4"
              >
                <path
                  d="M6 12a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 1 1 1.5 0v7.5A.75.75 0 0 1 6 12ZM18 12a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5A.75.75 0 0 1 18 12ZM6.75 20.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0ZM18.75 18.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 1.5 0ZM12.75 5.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0ZM12 21a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5A.75.75 0 0 1 12 21ZM3.75 15a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0ZM12 11.25a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5ZM15.75 15a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0Z"
                />
              </svg>
              Admin Panel
            </div>
          </div>
        </div>
        <!-- /Duplicated menu buttons to deal with scrollbar bullshit -->

        <!-- Hero Text -->
        <div
          class="px-8 flex flex-col justify-center lg:justify-start sm:px-16 lg:px-24 z-20"
        >
          <h4
            class="font-semibold uppercase text-white mb-2 text-lg text-center lg:text-left"
          >
            Careers at
          </h4>
          <h1
            v-if="settings.profile_title && settings.profile_title !== 'false'"
            class="mb-4 text-white text-center lg:text-left"
          >
            {{ settings.profile_title }}
          </h1>
          <p
            v-if="settings.profile_sub_title"
            class="text-white mb-4 text-lg font-thin text-center lg:text-left"
          >
            {{ settings.profile_sub_title }}
          </p>
          <a
            v-if="settings.profile_description"
            class="text-white text-center lg:text-left"
            @click="showReadMore"
            >Read more ></a
          >
        </div>
        <!-- /Hero Text -->

        <!-- Sign up grow container -->
        <div
          class="w-full transition-all overflow-hidden bg-truegray-700 primary-overlay-gradient-opac relative p-4 pb-8 lg:pb-4 flex flex-col items-center justify-center text-white z-40 mt-8 lg:mt-12"
          :class="[showSignUp ? ' gap-4' : '', showSignUpChoice ? '' : '']"
          :style="{ height: conditionalHeight }"
        >
          <!-- Top toggle always visible -->
          <div
            class="flex w-full items-center justify-center cursor-pointer gap-4 py-4 lg:py-0 z-20"
            @click="toggleShowSignUpChoice"
          >
            <p
              v-if="!showSignUpChoice"
              class="font-semibold text-sm text-sm text-center pt-4 lg:pt-0"
            >
              Click here to stay connected with {{ settings.profile_title }}
            </p>

            <p v-else class="font-semibold text-xs text-white uppercase">
              Close
            </p>

            <div
              v-if="!showSignUpChoice"
              :class="showSignUpChoice ? 'rotate-180 text-white' : ''"
              class="text-white transform transition-all"
            >
              <svg
                class="w-4 h-4"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.575 13.729C4.501 15.033 5.43 17 7.12 17h9.762c1.69 0 2.618-1.967 1.544-3.271l-4.881-5.927a2 2 0 0 0-3.088 0l-4.88 5.927Z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>

            <div v-else class="text-white transform transition-all">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                fill="currentColor"
                class="w-4 h-4"
              >
                <path
                  d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
                />
              </svg>
            </div>
          </div>
          <!-- /Top toggle always visible -->

          <!-- newsletter signup & conditional connection sign up -->
          <div
            class="flex flex-wrap lg:flex-nowrap items-center justify-center w-full z-20"
            :class="showSignUpChoice && !showSignUp ? 'mt-6' : ''"
          >
            <div
              :class="
                showSignUp ? 'justify-center' : 'w-full lg:w-1/2 lg:justify-end'
              "
              class="w-full flex items-center"
            >
              <!-- Newsletter sign up -->
              <div
                v-if="showSignUpChoice && formKey === 0"
                class="flex items-center w-full gap-4"
                :class="
                  !showSignUp
                    ? 'justify-center lg:justify-end'
                    : 'justify-center'
                "
              >
                <div
                  v-if="!showSignUp"
                  class="flex items-center border-b lg:border-b-0 lg:border-r border-white py-2 lg:pr-6 pb-4 lg:pb-2 cursor-pointer relative left hover-show-gradient"
                  @click="toggleShowSignUp"
                >
                  <p class="text-white z-20 text-center">
                    Sign up to receive regular updates
                  </p>
                  <div class="hidden lg:block text-white p-2 z-20 ml-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 16 16"
                      fill="currentColor"
                      class="w-4 h-4"
                    >
                      <path
                        d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z"
                      />
                      <path
                        d="M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z"
                      />
                    </svg>
                  </div>
                </div>
                <FormulateForm
                  v-if="showSignUp"
                  :key="formKey"
                  v-model="form"
                  name="contactForm"
                  class="flex flex-col items-center justify-center"
                  @submit="sendSignUp"
                >
                  <div class="flex items-center">
                    <FormulateInput
                      name="email"
                      placeholder="Email"
                      :input-class="['text-xs', 'rounded-l-full h-10']"
                    />
                    <FormulateInput
                      type="submit"
                      :disabled="signUpLoading"
                      :input-class="[
                        'rounded-l-full h-10 w-10 mb-0 style-override-in-style-block-1 relative px-2 right-6',
                        signUpLoading ? 'style-override-in-style-block-2' : '',
                      ]"
                    >
                      <span
                        v-if="signUpLoading"
                        class="w-8 h-8 flex items-center justify-center"
                      >
                        <lottie :options="loadingAnimationOptions" />
                      </span>
                      <span v-else>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="w-4 h-4"
                        >
                          <path
                            d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z"
                          />
                          <path
                            d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z"
                          />
                        </svg>
                      </span>
                    </FormulateInput>
                  </div>
                </FormulateForm>
              </div>
              <!-- /Newsletter sign up -->

              <!-- Newsletter success state -->
              <div
                v-if="formKey > 0"
                class="flex flex-col gap-4 items-center justify-center"
              >
                <div class="flex flex-col gap-1 items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="w-4 h-4"
                  >
                    <path
                      d="M19.5 22.5a3 3 0 0 0 3-3v-8.174l-6.879 4.022 3.485 1.876a.75.75 0 1 1-.712 1.321l-5.683-3.06a1.5 1.5 0 0 0-1.422 0l-5.683 3.06a.75.75 0 0 1-.712-1.32l3.485-1.877L1.5 11.326V19.5a3 3 0 0 0 3 3h15Z"
                    />
                    <path
                      d="M1.5 9.589v-.745a3 3 0 0 1 1.578-2.642l7.5-4.038a3 3 0 0 1 2.844 0l7.5 4.038A3 3 0 0 1 22.5 8.844v.745l-8.426 4.926-.652-.351a3 3 0 0 0-2.844 0l-.652.351L1.5 9.589Z"
                    />
                  </svg>
                  <p class="font-semibold text-sm">Success!</p>
                </div>

                <div class="flex items-center gap-4 text-white">
                  <p class="font-thin text-sm text-center">
                    Please check your emails to complete the sign up.
                  </p>
                </div>
              </div>
              <!-- /Newsletter success state -->
            </div>

            <!-- Conditional Connections sign ups -->
            <div v-if="!showSignUp && showSignUpChoice" class="w-full lg:w-1/2">
              <div
                class="flex items-center justify-center lg:justify-start py-2 pt-4 lg:pt-2 lg:pl-6 relative cursor-pointer right hover-show-gradient lg:w-[max-content]"
                @click="routeToAddConnection"
              >
                <div class="hidden lg:block text-white p-2 z-20 mr-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    class="w-4 h-4"
                  >
                    <path
                      d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM12.735 14c.618 0 1.093-.561.872-1.139a6.002 6.002 0 0 0-11.215 0c-.22.578.254 1.139.872 1.139h9.47Z"
                    />
                  </svg>
                </div>
                <p class="text-white z-20 text-center">
                  Learn about becoming a parent connection
                </p>
              </div>
            </div>
            <!-- /Conditional Connections sign ups -->
          </div>
          <!-- /newsletter signup & conditional connection sign up -->
        </div>
        <!-- Sign up grow container -->
      </div>
    </div>
    <!-- /Hero -->

    <!-- Explore Posts -->
    <div class="w-full bg-truegray-100 flex justify-center">
      <div class="w-full max-w-7xl 2xl:max-w-8xl px-8 2xl:px-0 py-16 relative">
        <h3 class="uppercase font-bold mb-4 text-center lg:text-left">
          Explore
        </h3>

        <div
          class="flex justfiy-center lg:justify-start items-center gap-x-3 sticky top-20 lg:top-32 z-40 bg-truegray-100 py-4 overflow-x-scroll no-scrollbar-custom"
        >
          <button
            type="button"
            class="btn uppercase w-max mb-0 gap-2 px-4"
            :class="activeExploreItem ? 'btn-trans-black' : 'btn-black'"
            @click="viewAllPosts"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="currentColor"
              class="w-5 h-5"
            >
              <path
                d="M3.5 2A1.5 1.5 0 0 0 2 3.5v2A1.5 1.5 0 0 0 3.5 7h2A1.5 1.5 0 0 0 7 5.5v-2A1.5 1.5 0 0 0 5.5 2h-2ZM3.5 9A1.5 1.5 0 0 0 2 10.5v2A1.5 1.5 0 0 0 3.5 14h2A1.5 1.5 0 0 0 7 12.5v-2A1.5 1.5 0 0 0 5.5 9h-2ZM9 3.5A1.5 1.5 0 0 1 10.5 2h2A1.5 1.5 0 0 1 14 3.5v2A1.5 1.5 0 0 1 12.5 7h-2A1.5 1.5 0 0 1 9 5.5v-2ZM10.5 9A1.5 1.5 0 0 0 9 10.5v2a1.5 1.5 0 0 0 1.5 1.5h2a1.5 1.5 0 0 0 1.5-1.5v-2A1.5 1.5 0 0 0 12.5 9h-2Z"
              />
            </svg>

            All
          </button>

          <button
            v-for="button in customisation.contentPostTypes"
            :key="'contentPostTypes-' + button.value"
            type="button"
            class="btn uppercase px-4 w-max mb-0 gap-2 whitespace-nowrap"
            :class="[
              emptyItems.emptyCategories.includes(button.value) ? 'hidden' : '',
              button.value === activeExploreItem || !activeExploreItem
                ? button.btnClass
                : 'btn-trans-black',
            ]"
            @click="updatePosts({ categories: [button.value] })"
          >
            <GeneralTagIcons :tag="button.text" />
            {{ button.text }}
          </button>

          <button
            v-for="button in customisation.contentTags"
            :key="'contentTags-' + button.value"
            type="button"
            class="btn text-white px-4 uppercase w-max mb-0 gap-2 whitespace-nowrap"
            :class="[
              emptyItems.emptyTags.includes(button.value) ? 'hidden' : '',
              button.value === activeExploreItem || !activeExploreItem
                ? button.btnClass
                : 'btn-trans-black',
            ]"
            @click="updatePosts({ tags: [button.value] })"
          >
            <GeneralTagIcons :tag="button.text" />
            {{ button.text }}
          </button>
          <div
            class="hidden bg-content-post-news bg-content-post-jobs bg-content-post-events bg-content-tag-0 bg-content-tag-1 bg-content-tag-2 bg-content-tag-3"
          ></div>
        </div>

        <div
          v-if="!loading && posts.length > 0"
          class="mt-8 grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-5 gap-6"
        >
          <PostCardExplore v-for="(post, i) in posts" :key="i" :post="post" />
        </div>
        <div v-else class="w-full flex items-center justify-center mt-8">
          <span class="h-16">
            <lottie :options="loadingAnimationOptions" />
          </span>
        </div>
      </div>
    </div>
    <!-- /Explore Posts -->

    <!-- Light mode search -->
    <div
      v-if="!isDarkMode"
      class="w-full bg-truegray-700 relative primary-overlay-gradient-opac px-8 py-8"
    >
      <p class="text-xs font-bold mb-4 text-white uppercase text-center">
        Looking for something else?
      </p>
      <div
        class="flex flex-col lg:flex-row gap-4 lg:gap-0 items-center justify-center z-20 relative"
      >
        <FormulateInput
          v-model="keywordSearch"
          name="keywords"
          label=""
          placeholder="Search"
          :input-class="['w-full rounded-full h-10']"
        />
        <button
          class="btn btn-primary m-0 ml-4 px-6 h-10 rounded z-20"
          @click="searchPosts"
        >
          Go!
        </button>
      </div>
    </div>
    <!-- /Light mode search -->

    <!-- Connections -->
    <div
      v-if="isConnectionsFeatureEnabled"
      :class="!isDarkMode ? 'bg-white' : 'bg-truegray-700 primary-overlay-opac'"
      class="w-full relative flex justify-center"
    >
      <div class="w-full max-w-7xl 2xl:max-w-8xl px-8 2xl:px-0 py-16 z-20">
        <h3
          :class="!isDarkMode ? '' : 'text-white'"
          class="uppercase font-bold mb-2"
        >
          CareerWise Connections
        </h3>
        <p :class="!isDarkMode ? '' : 'text-white'">
          Connect with people and organisations to fuel inspiration for career
          pathways
        </p>
        <div
          v-if="!connectionsLoading && connections && connections.length > 0"
          class="grid grid-cols-1 sm:grid-cols-2 2xl:grid-cols-3 gap-6 mt-12 z-20"
        >
          <CardConnection
            v-for="connection in connections"
            :key="connection.id"
            :connection="connection"
            context="CW"
          />
          <p
            v-if="
              !connections || (connections.length < 1 && !connectionsLoading)
            "
            class="italic"
          >
            No connections found...
          </p>
        </div>
        <div v-else class="w-full h-24 flex items-center justify-center">
          <lottie :options="loadingAnimationOptions" />
        </div>
      </div>
    </div>
    <!-- /Connections -->

    <!-- Contact form -->
    <div class="h-8 w-full bg-truegray-100" />
    <div id="contactForm" class="w-full bg-white flex justify-center">
      <div
        class="w-full max-w-7xl 2xl:max-w-8xl px-8 2xl:px-0 py-16 flex flex-wrap items-center"
      >
        <ContactForm />
      </div>
    </div>
    <!-- /Contact form -->
  </div>
</template>

<script>
import { defineComponent, onMounted, computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { useStore } from '../../../../../../js/store/index.js'
import { EventBus } from '../../../../../../js/plugins/event-bus.js'
import PostCardExplore from './PostCardExplore.vue'
import ContactForm from './ContactForm.vue'
import GeneralTagIcons from '../../../../../../shared/components/GeneralTagIcons.vue'
import CardConnection from '../../../../../shared/connections/components/CardConnection.vue'
import * as loadingAnimation from '../../../../../../shared/components/loading-dark.json'

export default defineComponent({
  name: 'Layout2Home',
  components: { PostCardExplore, ContactForm, GeneralTagIcons, CardConnection },

  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const loadingAnimationOptions = { animationData: loadingAnimation.default }
    const settings = computed(() => store.getters['shared/getSettings'])
    const customisation = computed(
      () => store.getters['careerwise/getCustomisationForUi'],
    )

    // Don't want to use the getter
    const isDarkMode = computed(() => customisation.value.theme === 0)

    const isConnectionsFeatureEnabled = computed(
      () => store.getters['careerwise/isConnectionsFeatureEnabled'],
    )
    const enableConnectionsSignup = computed(
      () => store.getters['careerwise/isConnectionsSignupEnabled'],
    )

    // General CTA clicks
    const showReadMore = () => {
      EventBus.$emit('showModal', 'read-more')
    }

    // #region - Sign up form
    const showSignUp = ref(false)

    const toggleShowSignUp = () => {
      showSignUp.value = !showSignUp.value
    }

    const conditionalHeight = computed(() => {
      // Check if viewport is larger than Tailwind's 'lg' breakpoint (1024px)
      const isLargeViewport = window.matchMedia('(min-width: 1024px)').matches

      if (!showSignUpChoice.value && formKey.value === 0) {
        return isLargeViewport ? '2.5rem' : '3.5rem'
      } else {
        return isLargeViewport ? '8rem' : '12rem'
      }
    })

    const showSignUpChoice = ref(false)
    watch(showSignUpChoice, (newVal) => {
      if (!newVal) {
        showSignUp.value = false
        formKey.value = 0
      } else if (!enableConnectionsSignup.value) {
        // If parent connections is toggled off, we should skip straight to the form step
        showSignUp.value = true
      }
    })
    const toggleShowSignUpChoice = () => {
      showSignUpChoice.value = !showSignUpChoice.value
    }

    const form = ref({})
    const signUpLoading = ref(false)

    const sendSignUp = async (payload) => {
      signUpLoading.value = true
      const response = await store.dispatch(
        'careerwise/dispatchNewsletterSignUp',
        payload,
      )
      if (response) {
        form.value = {}
        formKey.value++
      }
      signUpLoading.value = false
    }

    // Used to re-render the form after it has been successfully resolved in sending
    // Vue formulate doesn't SEEM to support reset methods while using the composition API
    const formKey = ref(0)

    const routeToAddConnection = () => {
      router.push({ name: 'AddConnection' })
    }
    // #endregion

    // #region - Posts
    const posts = computed(() => {
      return store.getters['careerwise/getHomePosts']
    })

    const loading = ref(false)
    const updatePosts = async (payload) => {
      loading.value = true

      if (payload.viewAll) {
        activeExploreItem.value = null
      } else if (payload.categories) {
        activeExploreItem.value = payload.categories[0]
      } else if (payload.tags) {
        activeExploreItem.value = payload.tags[0]
      }

      // API returns an object with 2 arrays for any tags or categories that do not have items
      // so we can hide them in the UI
      const doesntExist = await store.dispatch(
        'careerwise/dispatchUpdateHomePosts',
        payload,
      )

      // Only update the UI on fresh gets of viewAll as that is the only time that they are all looped through
      if (payload?.viewAll) {
        if (doesntExist) {
          emptyItems.value = doesntExist
        }
      }
      loading.value = false
    }

    const viewAllPosts = () => {
      const payload = {
        viewAll: true,
        categories: customisation.value.contentPostTypes.map(
          (type) => type.value,
        ),

        tags: customisation.value.contentTags.map((tag) => tag.value),
      }

      updatePosts(payload)
    }

    const activeExploreItem = ref(null)

    const emptyItems = ref({
      emptyCategories: [],
      emptyTags: [],
    })
    // #endregion

    // #region - Keyword search
    const keywordSearch = ref('')

    const searchPosts = () => {
      if (keywordSearch.value) {
        router.push({
          path: '/posts?keywords=' + keywordSearch.value,
        })
      }
    }
    // #endregion

    // #region - Connections
    const connections = computed(
      () => store.getters['connections/getOrganisationConnections'],
    )

    const connectionsLoading = ref(false)

    const getConnections = async ({
      context = 'CW',
      page = 1, // connectionsPagination.value.current_page ?
      filters = {},
      perPage = 8,
      randomise = true,
    } = {}) => {
      connectionsLoading.value = true
      await store.dispatch(
        'connections/dispatchUpdatePublicOrganisationConnections',
        {
          context,
          page,
          filters,
          perPage,
          randomise,
        },
      )
      connectionsLoading.value = false
    }
    // #endregion

    // #region - menu button duplication
    const user = computed(() => store.getters['shared/getUser'])
    const isOverflowing = ref(false)

    const checkOverflow = () => {
      let overflowMenu = document.getElementById('tenantMenu')
      let content = document.getElementById('tenantMenuContent')

      if (overflowMenu) {
        let overflowing = overflowMenu.scrollWidth < content.scrollWidth
        isOverflowing.value = overflowing
      }
    }

    const showFullMenu = () => {
      EventBus.$emit('showSmartMenu', true)
    }

    const openMarketingSite = () => {
      window.open('https://careerwise.school', '_blank')
    }

    const showSubscribeModal = () => {
      EventBus.$emit('showModal', 'subscribe')
    }

    const showLoginModal = () => {
      EventBus.$emit('showModal', 'login')
    }

    const openAdminMenu = () => {
      EventBus.$emit('showSmartMenu', true)
      EventBus.$emit('openAdminMenu')
    }

    const triggerLogOut = () => {
      EventBus.$emit('showModal', 'logout')
    }
    // #endregion

    onMounted(() => {
      viewAllPosts()
      checkOverflow()
      getConnections()
    })

    return {
      loadingAnimationOptions,
      settings,
      customisation,
      isDarkMode,
      isConnectionsFeatureEnabled,

      loading,
      posts,
      updatePosts,
      viewAllPosts,
      emptyItems,
      activeExploreItem,

      getConnections,
      connections,
      connectionsLoading,

      showSignUpChoice,
      toggleShowSignUpChoice,
      sendSignUp,
      showSignUp,
      toggleShowSignUp,
      conditionalHeight,
      form,
      signUpLoading,
      formKey,
      routeToAddConnection,

      showReadMore,

      keywordSearch,
      searchPosts,

      user,
      isOverflowing,
      showFullMenu,
      openMarketingSite,
      showSubscribeModal,
      showLoginModal,
      openAdminMenu,
      triggerLogOut,
    }
  },
})
</script>

<style scoped>
.home-banner::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 60%;
  z-index: 1;
  background: rgb(0, 0, 0);
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.5) 60%,
    rgba(0, 0, 0, 1) 100%
  );
}

.hover-show-gradient::after {
  content: '';
  position: absolute;
  top: 0;
  width: 90%;
  height: 100%;
  z-index: 10;
  transition: all 0.5s ease-in-out;
  opacity: 0;
  pointer-events: none;
}

.primary-overlay-opac::after {
  z-index: 1;
  width: 100%;
  height: 100%;
  content: '';
  position: absolute;
  inset: 0;
  background: var(--primary);
  opacity: 0.4;
}

.primary-overlay-gradient-opac::after {
  z-index: 1;
  width: 100%;
  height: 100%;
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(to right, var(--primary) 0%, transparent 100%);
  opacity: 0.4;
  pointer-events: none;
}

@media (min-width: 1024px) {
  .hover-show-gradient:hover::after {
    opacity: 0.3;
  }
}

.left.hover-show-gradient::after {
  right: 0;
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 50%,
    rgba(0, 0, 0, 1) 100%
  );
}

.right.hover-show-gradient::after {
  left: 0;
  background: linear-gradient(
    270deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 50%,
    rgba(0, 0, 0, 1) 100%
  );
}

.no-scrollbar-custom {
  scrollbar-width: thin;
  scrollbar-color: var(--cw-alt) transparent;
}

.no-scrollbar-custom::-webkit-scrollbar {
  width: 8px;
}

.no-scrollbar-custom::-webkit-scrollbar-thumb {
  background-color: var(--cw-alt);
  border-radius: 20px;
}
</style>

<style>
/* Sorry */
.style-override-in-style-block-1 {
  border-radius: 9999px !important;
  height: 2.5rem !important;
}
.style-override-in-style-block-2 {
  background: #fff !important;
}
</style>
